var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26795 3C9.03775 1.66667 10.9623 1.66667 11.7321 3L16.9282 12C17.698 13.3333 16.7358 15 15.1962 15H4.80385C3.26425 15 2.302 13.3333 3.0718 12L8.26795 3Z",
    fill: "#C70808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4922 11.2539H9.55469L9.42188 7.3125H10.625L10.4922 11.2539ZM10.0234 11.8711C10.2135 11.8711 10.3659 11.9271 10.4805 12.0391C10.5977 12.151 10.6562 12.2943 10.6562 12.4688C10.6562 12.6406 10.5977 12.7826 10.4805 12.8945C10.3659 13.0065 10.2135 13.0625 10.0234 13.0625C9.83594 13.0625 9.68359 13.0065 9.56641 12.8945C9.45182 12.7826 9.39453 12.6406 9.39453 12.4688C9.39453 12.2969 9.45182 12.1549 9.56641 12.043C9.68359 11.9284 9.83594 11.8711 10.0234 11.8711Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.f5bbb1ee7491846d0fb317c92c06a37f.svg";
export { ForwardRef as ReactComponent };